/* unplugin-vue-components disabled */import { render } from "./DashboardView.vue?vue&type=template&id=3c6a810a&scoped=true"
import script from "./DashboardView.vue?vue&type=script&lang=js"
export * from "./DashboardView.vue?vue&type=script&lang=js"

import "./DashboardView.vue?vue&type=style&index=0&id=3c6a810a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c6a810a"]])

export default __exports__